import { getDynamicAppConfigs } from '@javascript/habitual-analytics/constants/dynamicAppConfigs';
import { BROKER_CONFIG } from '@javascript/habitual-analytics/constants/habitual-configs';
import { fetchBrokerConfigs } from '@javascript/habitual-analytics/brokers/index';
import { defaultConfigs } from '@javascript/habitual-analytics/brokers/OrderFacade/defaultConfigs';
import { GetDynamicAppConfigs } from '@javascript/habitual-analytics/constants/types';
import { BrokerConfigs } from '@javascript/habitual-analytics/brokers/OrderFacade/types/insta';
import { isMobileView } from '@javascript/globals/components/withResponsiveProvider/helper';
import { isCurrentTimeWithinTradingHours } from '@javascript/habitual-analytics/utils/datetime';

export const getApiCredentials = (broker: string): Record<string, string | boolean | object> | undefined => {
  const dynamicAppConfigs: GetDynamicAppConfigs = getDynamicAppConfigs();
  const {
    brokerClientAccessToken,
    brokerClientId
  } = dynamicAppConfigs.brokerConfigs;
  const {
    FYERS_APP_ID,
    ARIHANT_PLUS_API_KEY,
    ARIHANT_PLUS_X_PARTNER_API_KEY,
    ARIHANT_PLUS_SOURCE,
  } = dynamicAppConfigs.envs;

  switch (broker) {
    case BROKER_CONFIG.fyers.id:
      return {
        apiKey: FYERS_APP_ID,
        accessToken: brokerClientAccessToken,
      };
    case BROKER_CONFIG.angel_broking.id:
      return {
        accessToken: brokerClientAccessToken,
      };
    case BROKER_CONFIG.stocko.id:
      return {
        accessToken: brokerClientAccessToken,
        clientId: brokerClientId,
        isMobile: isMobileView(),
      };
    case BROKER_CONFIG.arihant_plus.id:
      return {
        accessToken: brokerClientAccessToken,
        apiKey: ARIHANT_PLUS_API_KEY,
        brokerExtras: {
          isAfterMarketOrder: !isCurrentTimeWithinTradingHours(),
          xPartnerApiKey: ARIHANT_PLUS_X_PARTNER_API_KEY,
          source: ARIHANT_PLUS_SOURCE,
        },
      };
    case BROKER_CONFIG.iifl_capital.id:
      return {
        accessToken: brokerClientAccessToken,
      };
    default:
      return undefined;
  }
};

export const brokerSpecificTableHeaders = (): BrokerConfigs => {
  //Get labelConfigs from broker and merge with defaultConfigs
  const configs = fetchBrokerConfigs('getLabelConfigs');
  return { ...defaultConfigs, ...configs };
};

